/*eslint-disable eqeqeq */
const wishes = {
  state: {
    wishes: [
      //{ id: 1, name: 'Foo' },
      //{ id: 2, name: 'Bar' }
    ]
  },

  getters: {
    findWishByProductId: state => productId => {
      return state.wishes.find(wish => wish.product_id == productId);
    },

    filterWishesByKidId: state => id => {
      return state.wishes.filter(wish => wish.user_id == id);
    }
  },

  mutations: {
    addWish(state, newWish) {
      state.wishes = [
        ...state.wishes.filter(wish => wish !== newWish),
        newWish
      ];
    },

    addWishes(state, newWishes) {
      //create or update
      state.wishes = [
        ...state.wishes.filter(wish => {
          return newWishes.map(newWish => newWish.id).indexOf(wish.id) === -1;
        }),
        ...newWishes
      ];
    },

    removeWish(state, id) {
      state.wishes = state.wishes.filter(wish => wish.id !== id);
    }
  }
};

export default wishes;



// WEBPACK FOOTER //
// ./src/store/wishes.js